import { render } from "./PageNotFound.vue?vue&type=template&id=e09ff34a"
import script from "./PageNotFound.vue?vue&type=script&lang=js"
export * from "./PageNotFound.vue?vue&type=script&lang=js"
script.render = render

export default script